module.exports = __webpack_public_path__ + "img/655-3e3228.png";